// extracted by mini-css-extract-plugin
module.exports = {"wysiwyg":"wysiwyg-module--wysiwyg--1wc94"};